<form [formGroup]="form">
  <div class="row">
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.businessName }}</mat-label>
        <input type="text" formControlName="businessName" matInput />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.rif }}</mat-label>
        <input type="text" disabled [value]="form.value.rif" matInput />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.constitutionDate }}</mat-label>
        <input type="date" formControlName="constitutionDate" matInput />
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.economicActivity }}</mat-label>
        <mat-select
          [disabled]="!mun"
          formControlName="economicActivity"
          placeholder="Elaboración de productos alimenticios."
        >
          <mat-option *ngFor="let eco of economicActivity" [value]="eco">
            {{ eco }}
          </mat-option>
        </mat-select>
        <!-- <input
          type="text"
          formControlName="economicActivity"
          matInput
          placeholder="Elaboración de productos alimenticios."
        /> -->
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.specificActivity }}</mat-label>
        <input
          type="text"
          formControlName="specificActivity"
          matInput
          placeholder="Elaboración y distribución de pastas alimenticias."
        />
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.direction }}</mat-label>
        <input
          type="text"
          formControlName="direction"
          matInput
          placeholder="Avenida / Calle / Casa - Edificio / Piso - Nivel / Apartamento - Local."
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.state }}</mat-label>
        <!-- <input
          type="text"
          formControlName="state"
          matInput
          placeholder="Estado"
          *ngIf="form.value.placeOfBirth != 'VENEZUELA'"
        /> -->
        <mat-select
          (ngModelChange)="changeEstado($event)"
          formControlName="state"
          placeholder="Estado"
          (ngModelChange)="changeEstado($event)"
        >
          <mat-option *ngFor="let estad of est" [value]="estad">
            {{ estad }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.municipality }}</mat-label>
        <!-- <input
          type="text"
          formControlName="municipality"
          matInput
          placeholder="Municipio"
          *ngIf="form.value.placeOfBirth != 'VENEZUELA'"
        /> -->
        <mat-select
          (ngModelChange)="changeMunicipio($event)"
          [disabled]="!mun"
          formControlName="municipality"
          placeholder="Municipio"
        >
          <mat-option *ngFor="let muni of mun" [value]="muni">
            {{ muni }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.parish }}</mat-label>
        <!-- <input
          type="text"
          formControlName="parish"
          matInput
          placeholder="Parroquia"
          *ngIf="form.value.placeOfBirth != 'VENEZUELA'"
        /> -->
        <mat-select
          [disabled]="!parr"
          formControlName="parish"
          placeholder="Parroquia"
        >
          <mat-option *ngFor="let parro of parr" [value]="parro">
            {{ parro }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.phone1 }}</mat-label>
        <input
          type="text"
          formControlName="phone1"
          matInput
          placeholder="(0212) 462-35-32."
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <mat-label>{{ Texts.phone2 }}</mat-label>
        <input
          type="text"
          formControlName="phone2"
          matInput
          placeholder="(0426) 462-35-32"
        />
      </mat-form-field>
    </div>
    <div class="col-12">
      <p>
        <b>{{ Texts.institutionReportingClient }}</b>
      </p>
      <mat-radio-group
        aria-label="Select an option"
        formControlName="institutionReportingClient"
      >
        <mat-radio-button class="primary-radiobutton" [value]="true"
          >Si (cuando la persona mantiene algún instrumento o producto en la
          institución reportante).
        </mat-radio-button>
        <mat-radio-button class="primary-radiobutton" [value]="false"
          >No (cuando la persona no posee ningún producto o instrumento en la
          institución reportante).
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
</form>
